// extracted by mini-css-extract-plugin
export default {"trackInfoContainer":"ShareTripTracking_trackInfoContainer__EhCvP","rightSide":"ShareTripTracking_rightSide__Dd4jb","leftSide":"ShareTripTracking_leftSide__S8lHt"};